import React, { useState, useRef, useEffect } from "react";
import MainPageTextEditor, {
  FormattedMainPageText,
  useMainPageText,
} from "../MainPageTextEditor";
import "./style.css";

const DEFAULT_TEXT = {
  description:
    "Newsletter-ul meu este locul unde împărtășesc inspirație, ritualuri, recomandări și resurse menite să aducă mai mult echilibru și stare de bine în viața ta.",
};

const TEXT_FIELDS = [
  { key: "description", label: "Descriere", rows: 4 },
];

const COUNTRIES = [
  { code: "RO", flag: "🇷🇴", dial: "+40", name: "România" },
  { code: "AL", flag: "🇦🇱", dial: "+355", name: "Albania" },
  { code: "AU", flag: "🇦🇺", dial: "+61", name: "Australia" },
  { code: "AT", flag: "🇦🇹", dial: "+43", name: "Austria" },
  { code: "BE", flag: "🇧🇪", dial: "+32", name: "Belgia" },
  { code: "BG", flag: "🇧🇬", dial: "+359", name: "Bulgaria" },
  { code: "CA", flag: "🇨🇦", dial: "+1", name: "Canada" },
  { code: "CZ", flag: "🇨🇿", dial: "+420", name: "Cehia" },
  { code: "CY", flag: "🇨🇾", dial: "+357", name: "Cipru" },
  { code: "HR", flag: "🇭🇷", dial: "+385", name: "Croația" },
  { code: "DK", flag: "🇩🇰", dial: "+45", name: "Danemarca" },
  { code: "DE", flag: "🇩🇪", dial: "+49", name: "Deutschland" },
  { code: "CH", flag: "🇨🇭", dial: "+41", name: "Elveția" },
  { code: "AE", flag: "🇦🇪", dial: "+971", name: "Emiratele Arabe" },
  { code: "ES", flag: "🇪🇸", dial: "+34", name: "España" },
  { code: "EE", flag: "🇪🇪", dial: "+372", name: "Estonia" },
  { code: "FI", flag: "🇫🇮", dial: "+358", name: "Finlanda" },
  { code: "FR", flag: "🇫🇷", dial: "+33", name: "France" },
  { code: "GR", flag: "🇬🇷", dial: "+30", name: "Grecia" },
  { code: "IE", flag: "🇮🇪", dial: "+353", name: "Irlanda" },
  { code: "IL", flag: "🇮🇱", dial: "+972", name: "Israel" },
  { code: "IT", flag: "🇮🇹", dial: "+39", name: "Italia" },
  { code: "JP", flag: "🇯🇵", dial: "+81", name: "Japonia" },
  { code: "LV", flag: "🇱🇻", dial: "+371", name: "Letonia" },
  { code: "LT", flag: "🇱🇹", dial: "+370", name: "Lituania" },
  { code: "LU", flag: "🇱🇺", dial: "+352", name: "Luxemburg" },
  { code: "MK", flag: "🇲🇰", dial: "+389", name: "Macedonia de Nord" },
  { code: "MD", flag: "🇲🇩", dial: "+373", name: "Moldova" },
  { code: "NO", flag: "🇳🇴", dial: "+47", name: "Norvegia" },
  { code: "NL", flag: "🇳🇱", dial: "+31", name: "Olanda" },
  { code: "PL", flag: "🇵🇱", dial: "+48", name: "Polonia" },
  { code: "PT", flag: "🇵🇹", dial: "+351", name: "Portugal" },
  { code: "RS", flag: "🇷🇸", dial: "+381", name: "Serbia" },
  { code: "SK", flag: "🇸🇰", dial: "+421", name: "Slovacia" },
  { code: "SI", flag: "🇸🇮", dial: "+386", name: "Slovenia" },
  { code: "SE", flag: "🇸🇪", dial: "+46", name: "Suedia" },
  { code: "TR", flag: "🇹🇷", dial: "+90", name: "Turcia" },
  { code: "UA", flag: "🇺🇦", dial: "+380", name: "Ucraina" },
  { code: "HU", flag: "🇭🇺", dial: "+36", name: "Ungaria" },
  { code: "GB", flag: "🇬🇧", dial: "+44", name: "United Kingdom" },
  { code: "US", flag: "🇺🇸", dial: "+1", name: "United States" },
];

const EnhancedWellnews = () => {
  const [showForm, setShowForm] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [formData, setFormData] = useState({ name: "", email: "", phone: "" });
  const [loading, setLoading] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(COUNTRIES[0]);
  const [showCountryList, setShowCountryList] = useState(false);
  const countryWrapRef = useRef(null);
  const [content, setContent] = useMainPageText("wellnews", DEFAULT_TEXT);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Close country dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (countryWrapRef.current && !countryWrapRef.current.contains(e.target)) {
        setShowCountryList(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const fullPhone = formData.phone ? `${selectedCountry.dial} ${formData.phone}` : "";
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE}/newsletter/post`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ ...formData, phone: fullPhone }),
        },
      );
      if (response.ok) {
        setShowForm(false);
        setShowSuccess(true);
        setFormData({ name: "", email: "", phone: "" });
      }
    } catch (err) {
      console.error("Newsletter subscription error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="enhanced-wellnews main-page-text-editable">
      <MainPageTextEditor
        section="wellnews"
        sectionLabel="Wellnews"
        fields={TEXT_FIELDS}
        value={content}
        onSaved={setContent}
      />
      <div className="enhanced-wellnews__inner">
        <div className="enhanced-wellnews__header">
          <span className="enhanced-wellnews__pre-title">WELLNEWS</span>
          <h2 className="enhanced-wellnews__title">Alătură-te</h2>
          <p className="enhanced-wellnews__subtitle">comunității</p>
        </div>

        <p className="enhanced-wellnews__desc">
          <FormattedMainPageText text={content.description} />
        </p>

        <button
          className="enhanced-wellnews__btn"
          onClick={() => setShowForm(true)}
        >
          <svg
            className="enhanced-wellnews__whatsapp-icon"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
          </svg>
          Abonează-te la newsletter
        </button>
      </div>

      {/* Newsletter Form Modal */}
      {showForm && (
        <div className="wellnews-modal" onClick={() => setShowForm(false)}>
          <div
            className="wellnews-modal__card"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="wellnews-modal__close wellnews-modal__close--sm"
              onClick={() => setShowForm(false)}
              aria-label="Închide"
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
            <h3 className="enhanced-wellnews__title wellnews-modal__ds-title">
              Abonează-te
            </h3>
            <p className="enhanced-wellnews__subtitle wellnews-modal__ds-subtitle">
              la comunitate
            </p>
            <form className="wellnews-modal__form" onSubmit={handleSubmit}>
              <label className="wellnews-modal__field">
                <span className="wellnews-modal__label">Nume</span>
                <input
                  type="text"
                  name="name"
                  placeholder="Numele tău"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="wellnews-modal__input"
                />
              </label>
              <label className="wellnews-modal__field">
                <span className="wellnews-modal__label">Email</span>
                <input
                  type="email"
                  name="email"
                  placeholder="adresa@email.com"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="wellnews-modal__input"
                />
              </label>
              <label className="wellnews-modal__field">
                <span className="wellnews-modal__label">Telefon</span>
                <div className="wellnews-modal__phone-row">
                  <div className="wellnews-modal__country-wrap" ref={countryWrapRef}>
                    <button
                      type="button"
                      className="wellnews-modal__country-btn"
                      onClick={() => setShowCountryList((v) => !v)}
                      aria-label="Selectează țara"
                    >
                      <span className="wellnews-modal__country-flag">{selectedCountry.flag}</span>
                      <span className="wellnews-modal__country-dial">{selectedCountry.dial}</span>
                      <svg className="wellnews-modal__country-caret" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                        <polyline points="6 9 12 15 18 9" />
                      </svg>
                    </button>
                    {showCountryList && (
                      <div className="wellnews-modal__country-list">
                        {COUNTRIES.map((c) => (
                          <button
                            key={c.code}
                            type="button"
                            className="wellnews-modal__country-option"
                            onClick={() => { setSelectedCountry(c); setShowCountryList(false); }}
                          >
                            <span>{c.flag}</span>
                            <span className="country-name">{c.name}</span>
                            <span className="country-dial">{c.dial}</span>
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="700 000 000"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    className="wellnews-modal__phone-input"
                  />
                </div>
              </label>
              <button
                type="submit"
                className="wellnews-modal__submit"
                disabled={loading}
              >
                {loading ? "Se trimite..." : "Trimite"}
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Success Modal */}
      {showSuccess && (
        <div className="wellnews-modal" onClick={() => setShowSuccess(false)}>
          <div
            className="wellnews-modal__card wellnews-modal__card--success"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="wellnews-modal__close wellnews-modal__close--sm"
              onClick={() => setShowSuccess(false)}
              aria-label="Închide"
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>

            {/* Animated circle check */}
            <div className="wellnews-modal__check-wrap">
              <svg className="wellnews-modal__check-svg" viewBox="0 0 52 52">
                <circle
                  className="wellnews-modal__check-circle"
                  cx="26"
                  cy="26"
                  r="23"
                  fill="none"
                />
                <polyline
                  className="wellnews-modal__check-tick"
                  points="14,26 22,34 38,18"
                  fill="none"
                />
              </svg>
            </div>

            <h3 className="wellnews-modal__title">Mulțumim!</h3>
            <p className="wellnews-modal__success-text">
              Ești acum parte din comunitate. Te vom ține la curent cu toate
              noutățile.
            </p>
            <p className="wellnews-modal__success-sub">
              Intră în comunitatea noastră de WhatsApp:
            </p>
            <a
              href="https://chat.whatsapp.com/CW46RoLO4UA9uH1YIwLeJq?mode=gi_t"
              target="_blank"
              rel="noopener noreferrer"
              className="wellnews-modal__community-btn"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
              </svg>
              Intră în comunitate
            </a>
          </div>
        </div>
      )}
    </section>
  );
};

export default EnhancedWellnews;
